import { Pipe, PipeTransform } from "@angular/core";

@Pipe({
    name: "authorizationStatusBadge",
    standalone: false
})
export class AuthorizationStatusBadgePipe implements PipeTransform {
    transform(id: number): string {
        switch (id) {
            case 0: return "SIGNATURE REQUESTED" // FOLO
            case 1: return "SIGNATURE REQUESTED" // ROLO
            case 2: return "SIGNATURE REQUESTED" // WO
            case 3: return "REVIEW RO FUNDING"
            case 4: return "FUNDING AUTHORIZED" // RO
            case 5: return "REVIEW WO FUNDING"
            case 6: return "FUNDING AUTHORIZED"
            case 7: return "COMPLETED - NO FUNDING"
            default: return id.toString();
        }
    }
}